"use client";
import React from "react";
import Card from "@/components/primitives/card";
import Tabs, { TabItem } from "@/components/primitives/tabs";
import TeamLogo from "@/components/team/logo";
import { Sport, TeamBasic, TopLeaders, createServerSeason } from "common";
import useFetch from "@/utils/fetch";
import {
  TeamTopLeaderData,
  getTeamTopLeaderData,
} from "@/app/(public)/[sport]/teams/[team]/[year]/data";
import { convertDateToStringWithoutTime, getYearFromDateString, toDateString } from "@/utils";

export default function TopLeaderStats({
  sport,
  homeTeam,
  awayTeam,
  date,
  season,
}: {
  sport: Sport;
  homeTeam: TeamBasic;
  awayTeam: TeamBasic;
  date: string;
  season: number;
}) {
  const [view, setView] = React.useState<string>("away");

  /**
   * @TODO change to server fetch, change year/season.
   */
  const baseUrl: string = `${process.env.NEXT_PUBLIC_API_URL}/api/sports/${sport}/${createServerSeason(getYearFromDateString(toDateString(date)), season)}/top-leaders/`;
  const params: URLSearchParams = new URLSearchParams();
  params.append("homeKey", homeTeam.abbreviation);
  params.append("awayKey", awayTeam.abbreviation);
  const request: string = `${baseUrl}?${params}`;
  const { data, isLoading, isError, error } = useFetch<{
    away: TopLeaders;
    home: TopLeaders;
  } | null>(null, request, []);
  const items: TabItem[] = [
    {
      label: (
        <div className="flex items-center max-h-[20px] gap-2">
          <TeamLogo team={awayTeam} size="sm" />{" "}
          <span>{awayTeam.abbreviation}</span>
        </div>
      ),
      value: "away",
    },
    {
      label: (
        <div className="flex items-center max-h-[20px] gap-2">
          <TeamLogo team={homeTeam} size="sm" />{" "}
          <span>{homeTeam.abbreviation}</span>
        </div>
      ),
      value: "home",
    },
  ];
  if (data) {
    console.log("top leaders: ", data);
    const currentData = view === "away" ? data.away : data.home;
    const topLeaderData: TeamTopLeaderData[] =
      getTeamTopLeaderData(currentData);
    return (
      <Card
        className="!pt-4"
        header={{
          title: "Top Leader Stats",
          action: (
            <div className="overflow-x-auto">
              <Tabs
                variant="pill"
                label="Top Leader Stats Filters"
                value={view}
                items={items}
                onValueChange={(v) => setView(v)}
              />
            </div>
          ),
        }}
      >
        <div className="grid grid-cols-2 xs:grid-cols-3 desktop-grid:grid-cols-3 gap-y-4">
          {topLeaderData.map((item, i) => (
            <StatCard
              key={i}
              label={item.label as string}
              name={item.name}
              value={item.value}
              abbreviation={item.abbreviation}
              sport={item.sport}
            />
          ))}
        </div>
      </Card>
    );
  }
}

function StatCard({
  label,
  name,
  value,
  abbreviation,
  sport,
}: {
  label: string;
  name: string;
  value: string;
  abbreviation: string;
  sport: Sport;
}) {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <img
        src={`/images/player/headshot-${sport}.png`}
        className="max-w-[80px] max-h-[110px] desktop-grid:max-w-[100px] desktop-grid:max-h-[160px]"
        alt="Nfl Player"
      />
      <div className="flex flex-col gap-2 justify-center text-center items-center">
        <div className="text-label-sm-medium sm:text-title-lg-medium text-dark flex items-center">
          {name}
        </div>
        <div className="w-4 h-px bg-secondary-700"></div>
        {/* <div className="text-label-lg-bold uppercase">{label}</div> */}
      </div>
      <div className="flex flex-col gap-1 items-center">
        <div className="text-display text-[20px] sm:text-[32px] text-dark">{value}</div>
        <div className="text-title-sm-medium text-secondary uppercase">
          {abbreviation}
        </div>
      </div>
    </div>
  );
}
